import axios from 'axios';
import { toast } from 'react-toastify';
import {
  APP_SETTING_CHANGE_ENCRYPTION_TYPE_BEGIN,
  APP_SETTING_CHANGE_ENCRYPTION_TYPE_SUCCESS,
  APP_SETTING_CHANGE_ENCRYPTION_TYPE_FAILURE,
  APP_SETTING_CHANGE_ENCRYPTION_TYPE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function changeEncryptionType(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_CHANGE_ENCRYPTION_TYPE_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/change-encryption`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_CHANGE_ENCRYPTION_TYPE_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_CHANGE_ENCRYPTION_TYPE_FAILURE,
              data: { error: err },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_CHANGE_ENCRYPTION_TYPE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissChangeEncryptionTypeError() {
  return {
    type: APP_SETTING_CHANGE_ENCRYPTION_TYPE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_CHANGE_ENCRYPTION_TYPE_BEGIN:
      return {
        ...state,
        changeEncryptionTypePending: true,
        changeEncryptionTypeError: null,
      };

    case APP_SETTING_CHANGE_ENCRYPTION_TYPE_SUCCESS:
      return {
        ...state,
        changeEncryptionTypePending: false,
        changeEncryptionTypeError: null,
        projectDetail: {
          ...state.projectDetail,
          changeEncryptionType: action.data.changeEncryptionType,
        },
      };

    case APP_SETTING_CHANGE_ENCRYPTION_TYPE_FAILURE:
      return {
        ...state,
        changeEncryptionTypePending: false,
        changeEncryptionTypeError: action.data.error,
      };

    case APP_SETTING_CHANGE_ENCRYPTION_TYPE_DISMISS_ERROR:
      return {
        ...state,
        toggleEncryptionError: null,
      };

    default:
      return state;
  }
}
